import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { MatIconRegistry } from '@angular/material/icon';

import { FsOffline } from '@firestitch/offline';
import { FsProgressModule } from '@firestitch/progress';
import { FsWebSocket } from '@firestitch/web-socket';

import { AppService, SessionService } from './core';
import { AnalyticsService } from './core/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FsProgressModule, RouterOutlet],
})
export class AppComponent {
  private _offline = inject(FsOffline);
  private _appService = inject(AppService);
  private _fsWebSocket = inject(FsWebSocket);
  private _iconRegistry = inject(MatIconRegistry);
  private _sessionService = inject(SessionService);
  private _analyticsService = inject(AnalyticsService);


  // Timer service injected here to construct service on app init. Don't remove
  // Global Drawer service injected here to construct service on app init. Don't remove
  constructor() {
    this._offline.init();
    this._appService.init();
    this._analyticsService.init();
    this._iconRegistry.setDefaultFontSetClass('material-symbols-outlined');


    if (this._appService.settings.websocketEnabled) {
      this._sessionService.account$()
        .subscribe((store: any) => {
          if (store) {
            this._fsWebSocket.connect();
          } else {
            this._fsWebSocket.disconnect();
          }
        });
    }
  }

}
